<ng-container *ngIf="vm$ | async as vm">
    <ng-container *ngIf="vm?.totalMeasureCount > 0">
        <div fxLayout.gt-sm="row" fxLayout.sm="column" fxFlexOffset.gt-sm="15" class="statistics" ngClass.gt-sm="desktop" ngClass.sm="sm" ngClass.xs="xs">
            <div fxFlex.gt-sm="20" fxLayout.gt-sm="column" fxLayout.xs="column" fxLayout.sm="row" class="overview">
                <div fxFlex fxLayout.gt-sm="column" fxLayout.sm="column">
                    <div fxFlex.sm class="status-on">Status on {{ today | date : 'dd MMMM yyyy' }}</div>
                    <div fxFlex.gt-sm fxLayout="row" fxLayoutAlign="start center" class="status-header">Status of MARIS database</div>
                </div>
                <div fxFlex.sm class="status-total">
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        Total samples: <span>{{ vm.totalSampleCount | number : '2.' }}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        Total measurements: <span>{{ vm.totalMeasureCount | number : '2.' }}</span>
                    </div>
                </div>
            </div>
            <div fxLayout.xs="row wrap" fxFlex.sm fxFlex.gt-sm="80" ngClass.sm="mt-4">
                <div fxFlex="25" fxFlex.xs="50" *ngFor="let measurement of vm.measurements" fxLayout="column" fxLayoutAlign.xs="center center" fxLayout.lt-md="row" class="item" ngClass.xs="p-3">
                    <div class="measure-block h-100" (click)="generateLink(measurement.id)" fxLayout="column" fxLayoutAlign="space-between center">
                        <img class="sample-type-icon" src="/assets/icons/svg/st{{ measurement.id }}_icon.svg" alt="{{ measurement.type }}" />
                        <div fxLayout="column" fxLayoutAlign="start center">
                            <div class="item-title">
                                {{ measurement.type }}
                            </div>
                            <div class="samples">
                                Samples: <br />
                                <span class="count">{{ measurement.samplecount | number : '2.' }}</span>
                            </div>
                            <div class="measurements">
                                Measurements: <br />
                                <span class="count">{{ measurement.measurecount | number : '2.' }}</span>
                            </div>
                            <span class="link">Explore on map</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</ng-container>
